let menu = [];

export function setMenu(menuConfig) {
  menu = [...menuConfig];
}

export { menu };
